import { memo } from 'react';

import { PresentationIcon } from '@air/design-icons';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { useMainSideNavItemSelected } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavItemSelected';
import { Routes } from '~/constants/routes';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';

export type MainSideNavItemShowcasesProps = {
  pathname: string;
};

export const MainSideNavItemShowcases = memo(({ pathname }: MainSideNavItemShowcasesProps) => {
  const { collectionsEnabled } = useFeatureFlags();
  const { isSelected } = useMainSideNavItemSelected({
    isRouteSelected: pathname === Routes.showcases,
  });

  if (!collectionsEnabled) {
    return null;
  }

  return (
    <MainSideNavItem
      href={Routes.showcases}
      icon={PresentationIcon}
      id="showcases"
      isSelected={isSelected}
      label="Showcases"
      sidebarInteractionType="share_links"
    />
  );
});

MainSideNavItemShowcases.displayName = 'MainSideNavItemShowcases';
